import { useEffect, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface Props {
  title: string
  onClose: () => void
  children: ReactNode
  /** Optional row of actions shown under the title, before the scrolling body */
  actions?: ReactNode
}

/**
 * A modal list dialog. Rendered into document.body: the phone sidebar is a transformed drawer,
 * which would otherwise trap a fixed-position overlay inside it.
 */
export default function Dialog({ title, onClose, children, actions }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return createPortal(
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal list-dialog" role="dialog" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <header className="list-dialog-head">
          <h3>{title}</h3>
          <button className="link modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        {actions && <div className="list-dialog-actions">{actions}</div>}
        <div className="list-dialog-body">{children}</div>
      </div>
    </div>,
    document.body,
  )
}
